import React, { memo, useCallback, useEffect, useState } from 'react';

import { ArchivePlaceholder } from './ArchivePlaceholder';
import { ImagePlaceholder } from './ImagePlaceHolder';
import { VideoPlaceholder } from './VideoPlaceholder';

import * as Styles from './styles';
import { AuthorizeView, Loading } from 'components';
import { useBrokenText } from 'hooks/useBrokenText';
import { getClientFile } from 'services/getDemandData';
import { openNotification } from 'utils/notification';
import { Box } from '@chakra-ui/react';

export enum cardTypes {
  image = 1,
  document = 2,
  video = 3,
}

interface IProps {
  type: cardTypes;
  id: number | string;
  filename: string;
  clientName?: string;
  date?: string;
}

const CardComponent: React.FC<IProps> = ({ type, id, filename, clientName, date }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [img, setImg] = useState('');
  const [piecetTxt, fullTxt, isSmall] = useBrokenText(filename, 16);
  const getImg = useCallback(
    async (noCatch?: boolean) => {
      try {
        const { data } = await getClientFile(id);
        return data;
      } catch (err) {
        if (noCatch) return '';
        throw err;
      }
    },
    [id],
  );
  const handleDownloadFile = useCallback(async () => {
    try {
      setIsLoading(true);
      const data: any = await getImg();
      const a = document.createElement('a');
      a.onclick = () => {
        document.body.removeChild(a);
      };

      a.href = URL.createObjectURL(data);
      a.download = filename;
      a.rel = 'noopener noreferrer';
      a.target = '_blank';

      document.body.appendChild(a);

      a.click();
    } catch (err) {
      console.error(err);
      openNotification('Ocorreu um erro ao baixar o arquivo', 'error');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    let img = '';
    const gt = async () => {
      const blobImg = await getImg();
      if (blobImg) {
        img = URL.createObjectURL(blobImg);
        setImg(img);
      }
    };
    gt();
    return () => {
      if (img) URL.revokeObjectURL(img);
    };
  }, [getImg]);

  return (
    <Styles.Container isLoading={isLoading} onClick={handleDownloadFile}>
      {isLoading ? (
        <Loading />
      ) : (
        <Styles.MediaContainer>
          {type === cardTypes.document ? (
            <ArchivePlaceholder />
          ) : type === cardTypes.image ? (
            <ImagePlaceholder img={img} />
          ) : (
            <VideoPlaceholder />
          )}
        </Styles.MediaContainer>
      )}
      <Styles.Footer>
        <Box aria-label="data solicitação" fontSize="12px">
          {date}
        </Box>

        <AuthorizeView onlyAdmin>
          <strong>{clientName}</strong>
        </AuthorizeView>

        <Box fontSize="16px" fontWeight={700}>
          {isSmall ? fullTxt : `${piecetTxt}...`}
        </Box>
      </Styles.Footer>
    </Styles.Container>
  );
};

export const Card = memo(CardComponent);
